import { getParams } from '@hatchd/utils';
import AuthForm, { LoginFormMode } from 'components/auth-form';
import { H4 } from 'components/headings';
import Layout from 'components/layout';
import SEO from 'components/seo';
import ContentSection from 'components/ui/content-section';
import { GetStaticProps, NextPage } from 'next';
import React, { useState } from 'react';
import { useEffectOnce, useMount } from 'react-use';
import AnalyticsService, { ScreenNames } from 'services/analytics';
import { backgroundImages } from 'utils/config';

const PAGE_TITLE = 'Sign in';
const PAGE_DESCRIPTION = 'Sign in to your My Bushfire Plan account.';

const SignUp: NextPage = () => {
  const [userEmail, setEmail] = useState<string | undefined>(undefined);

  useMount(() => {
    const { email } = getParams<{ email: string }>(window.location.search);
    const decodedEmail =
      typeof email === 'string' ? decodeURIComponent(email) : undefined;
    setEmail(decodedEmail);
  });

  useEffectOnce(() => {
    AnalyticsService.trackScreen(ScreenNames.login);
  });

  return (
    <Layout mainBackground={backgroundImages.hero}>
      <SEO title={PAGE_TITLE} description={PAGE_DESCRIPTION} />
      <ContentSection textAlign='center'>
        <H4 as='h1'>Login to your account</H4>
        <AuthForm mode={LoginFormMode.login} email={userEmail} />
      </ContentSection>
    </Layout>
  );
};

export const getStaticProps: GetStaticProps = async () => {
  return {
    props: {},
  };
};

export default SignUp;
